import { z } from 'zod'
import { isValidCNPJ } from '@/shared/utils/validate-cnpj'

// Regex para validação de CNPJ formatado (XX.XXX.XXX/XXXX-XX)
const cnpjFormattedRegex = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/

/**
 * Schema Zod para CNPJ formatado (XX.XXX.XXX/XXXX-XX)
 * Valida formato e dígitos verificadores
 */
export const cnpjSchema = z
  .string()
  .min(18, 'CNPJ deve ter 14 dígitos')
  .max(18, 'CNPJ deve ter 14 dígitos')
  .refine((val) => cnpjFormattedRegex.test(val), {
    message: 'CNPJ deve estar no formato XX.XXX.XXX/XXXX-XX',
  })
  .refine((val) => isValidCNPJ(val), {
    message: 'CNPJ inválido',
  })

/**
 * Schema Zod para CNPJ opcional (permite vazio)
 */
export const optionalCnpjSchema = z
  .string()
  .refine(
    (val) => {
      if (!val || val === '') return true

      return cnpjFormattedRegex.test(val) && isValidCNPJ(val)
    },
    { message: 'CNPJ inválido' },
  )
  .optional()
  .or(z.literal(''))

/**
 * Schema Zod para CNPJ não formatado (apenas dígitos)
 * Útil para enviar ao backend
 */
export const cnpjRawSchema = z
  .string()
  .length(14, 'CNPJ deve ter 14 dígitos')
  .regex(/^\d{14}$/, 'CNPJ deve conter apenas números')
  .refine((val) => isValidCNPJ(val), {
    message: 'CNPJ inválido',
  })
